import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { declineRentRequest } from '@api/assetsRent';

import { ESnackbarTypes } from '@enums/common';

import { ASSET_RENT_REQUEST_CARD } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateDeclineRentRequest = (id: string, onSuccessCallbacks: Array<() => void>) => {
	const dispatch = useAppDispatch();

	const { mutateAsync: declineRequest } = useMutation({
		mutationKey: [ASSET_RENT_REQUEST_CARD, id],
		mutationFn: (comment?: string) => id && declineRentRequest(id, comment),
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.assetRentDeclineSuccess,
				type: ESnackbarTypes.success,
			}));

			if (onSuccessCallbacks.length) {
				onSuccessCallbacks.forEach((callback) => callback());
			}
		},
		enabled: [id],
	});

	return {
		declineRequest: declineRequest as (comment?: string) => Promise<void>,
	};
};
